import React, {Component} from 'react';
import classes from './BurgerIngredient.css';
import PropTypes from 'prop-types';

class BurgerIngredient extends Component
{
    render()
    {

    // initialize to null (will be passed in as a type of ingredient)
    let ingredient = null;

    // swtich statement to check what ingedient was sent in as a prop
    switch(this.props.type) // the prop we are sending over will be called 'type'
    {
        case ('bread-bottom'):
            ingredient = <div className = {classes.BreadBottom}></div>;
            break;
        case ('bread-top'):
            ingredient = (<div className = {classes.BreadTop}>
                <div className = {classes.Seeds1}></div>
                <div className = {classes.Seeds2}></div>
            </div>
            );
            break;
        case ('meat'):
            ingredient = <div className = {classes.Meat}></div>;
            break;
        case ('cheese'):
            ingredient = <div className = {classes.Cheese}></div>;
            break;
        case ('lettuce'):
            ingredient = <div className = {classes.Lettuce}></div>;
            break;
        case ('bacon'):
            ingredient = <div className = {classes.Bacon}></div>;
            break;
        default:
            ingredient = null;

    }

    return ingredient;

    }
   
};

BurgerIngredient.propTypes = {
    type: PropTypes.string.isRequired // the ingredient MUST be a string
};

export default BurgerIngredient;


// WEBPACK FOOTER //
// ./src/components/Burger/BurgerIngredient/BurgerIngredient.js